var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"d-flex",class:!_vm.isDesktop ? 'py-0 mt-2' : '',attrs:{"cols":"12","md":"4"}},[_vm._t("colLeft")],2),_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","md":"8"}},[_vm._t("colRight")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }